import React, {Fragment} from 'react';
import Sections from "../components/Sections";
import AddSection from "./AddSection";
import {connect} from 'react-redux';
import Title from "./header/Title";
import Photo from "./header/Photo";
import Presenter from '../presenters/PostForm'

function PostForm(props) {

    function save(event) {
        event.preventDefault();
        new Presenter().cleanAndSend(props);
    }

    let {title, photo, sections} = props;

    return (
        <Fragment>
            <div className="col-md-12">
                <form onSubmit={save}>
                    <div className="col-md-2 offset-md-10 pl-7">
                        <button className="btn-success py-2 px-4" type="submit">GUARDAR</button>
                    </div>
                    <Title text={title}/>
                    <Photo text={photo}/>
                    <Sections sections={sections}/>
                </form>
            </div>
            <AddSection/>
        </Fragment>
    );

}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(PostForm);


// WEBPACK FOOTER //
// ./src/admin/components/editor/containers/PostForm.js